import React from 'react';
import Widget from "../../../../../components/prefabricated/Widget";
import {Row} from "reactstrap";
import LanguageSelect from "../../../../../components/customBreachBits/settings/LanguageSelect";
import PageZoomSelect from "../../../../../components/customBreachBits/settings/PageZoomSelect";
import DarkModeRadio from "../../../../../components/customBreachBits/settings/DarkModeRadio";
import CustomHomePageSelect from "../../../../../components/customBreachBits/settings/CustomHomePageSelect";
import EmailOptInRadio from "../../../../../components/customBreachBits/settings/EmailOptInRadio";
import EmailFrequencySelect from "../../../../../components/customBreachBits/settings/EmailFrequencySelect";
import EmailUpdateCheckbox from "../../../../../components/customBreachBits/settings/EmailUpdateCheckbox";
import OtherEmailsRadio from "../../../../../components/customBreachBits/settings/OtherEmailsRadio";
import DefaultTableSizeSelect from "../../../../../components/customBreachBits/settings/DefaultTableSizeSelect";
import TipandToursRadio from "../../../../../components/customBreachBits/settings/TipAndToursRadio";
import {Tooltip} from "@material-ui/core";
import ChangePasswordTextInput from "../../../../../components/customBreachBits/settings/ChangePasswordTextInput";
import ChangeEmailTextInput from "../../../../../components/customBreachBits/settings/ChangeEmailTextInput";
import MFAToggleSwitch from "../../../../../components/customBreachBits/settings/MFAToggleSwitch";
import ComingSoonIconSettings from "../../../../../components/customBreachBits/settings/ComingSoonIconSettings";
import BRLabFeaturesOptIn from "../../../../../components/customBreachBits/settings/BRLabFeaturesOptIn";
import EarlyAccessWrapper from "../../../../../components/customBreachBits/settings/EarlyAccessWrapper";
import BRLabsWrapper from "../../../../../components/customBreachBits/settings/BRLabsWrapper";
import {bbFindUserTagsByTagId} from "../../../../../util/bbHelpers";

const UserSettingsWidget = ({customer = null, authUser=null,}) => {

    const emailOptInTags = bbFindUserTagsByTagId(authUser, 14);
    const getsEmails = emailOptInTags && emailOptInTags.length > 0;
    const isDisabled = true;
    const textColor = isDisabled && "text-light-gray";


    return(
        // <Widget styleName={`p-2  `}>
            <div className={"m-2 p-5 app-main-content bg-light"}>
                <Row>
                    <h4 className={"col-12 text-left"}>
                        Settings
                    </h4>
                </Row>

                <CustomHomePageSelect />
                {/*<LanguageSelect/>*/}
                {/*<PageZoomSelect/>*/}
                {/*<DarkModeRadio/>*/}

                <DefaultTableSizeSelect/>
                <TipandToursRadio/>
                <hr className={"m-2 p-2"}/>

                <Row>
                    <h4 className={"col-12 text-left align-self-center"}>
                        Notifications
                    </h4>
                </Row>

                <EmailOptInRadio />
                {getsEmails &&
                    <span>
                        <EmailFrequencySelect />
                        {/*<EmailUpdateCheckbox/>*/}
                    </span>
                   }

                <hr className={"m-2 p-2"}/>

                <Row>
                    <h4 className={"col-12 text-left"}>
                        Security and Privacy
                    </h4>
                </Row>

                <ChangePasswordTextInput/>
                <ChangeEmailTextInput/>
                <MFAToggleSwitch/>

                <hr className={"m-2 p-2"}/>

                <Row>
                    <h4 className={"col-12 text-left"}>
                        Other Emails
                    </h4>
                </Row>


                <OtherEmailsRadio />

                <hr className={"m-2 p-2"}/>

                <Row>
                    <h4 className={"col-12 text-left"}>
                        BreachRisk Lab
                    </h4>
                </Row>

                <BRLabFeaturesOptIn/>
                <BRLabsWrapper>
                    <div className={`row align-self-center`}>
                        <p className={"col-3"}> </p>
                        <p className={"col-6 text-center align-self-center"}>This is where the available lab features will go.</p>
                        <p className={"col-3"}> </p>
                    </div>
                </BRLabsWrapper>

            </div>

         // </Widget>

    )
}

export default UserSettingsWidget;